import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import { API_ENDPOINT } from '../../../constants';
import xIcon from '../../../assets/svg/x.svg';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'

import Checkbox from '../../../components/forms/fields/checkbox';
import { getColorLateEarly, getExtendedPaymentManagement, getGroupPaymentMethods, getHumanReadable, getHumanReadableReasonForChange, getReasonsForChange } from '../helper';
import DynamicListText from '../fields/dynamicListText';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class CancellationAndRefundSettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            }
        };
        this._isInitial = true;
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    setInitialData = () => {
        const currency = this.getCurrency();

        const groupData = this.getGroupData();
        const paymentSettings = groupData?.paymentSettings ?? {};
        const clinicId = this.props.selectedClinic;
        const cancellationAndRefundSettings = paymentSettings?.cancellationAndRefundSettings?.[clinicId] ?? {};

        const patientActions = cancellationAndRefundSettings?.patientActions ?? {};
        const clinicActions = cancellationAndRefundSettings?.clinicActions ?? {};
        const infoTextToPatientCancelOrReschedule = cancellationAndRefundSettings?.infoTextToPatientCancelOrReschedule ?? {};

        let form = {
            lateCancellationPeriod: cancellationAndRefundSettings?.lateCancellationPeriod ?? '',
            patientActions: {
                // markEarlyCancellationAsRefundRequest: patientActions?.markEarlyCancellationAsRefundRequest ?? false,
                automaticallyRefundEarlyCancellations: false, // patientActions?.automaticallyRefundEarlyCancellations ?? false,
                preventEarlyCancellation: patientActions?.preventEarlyCancellation ?? false,
                preventEarlyRescheduling: patientActions?.preventEarlyRescheduling ?? false,
                preventLateCancellation: patientActions?.preventLateCancellation ?? false,
                preventLateRescheduling: patientActions?.preventLateRescheduling ?? false
            },
            clinicActions: {
                // markEarlyCancellationAsRefundRequest: clinicActions?.markEarlyCancellationAsRefundRequest ?? false,
                automaticallyRefundEarlyCancellations: false, // clinicActions?.automaticallyRefundEarlyCancellations ?? false,
                // allowLateCancellationRefund: clinicActions?.allowLateCancellationRefund ?? false,
                allowClinicianToRefundPayment: clinicActions?.allowClinicianToRefundPayment ?? false,
                allowClinicianToCreateAndEditPayments: clinicActions?.allowClinicianToCreateAndEditPayments ?? false,
                allowClinicianToCancelAnUnpaidPayment: clinicActions?.allowClinicianToCancelAnUnpaidPayment ?? false,
                allowClinicianToAttachInvoices: clinicActions?.allowClinicianToAttachInvoices ?? false,
                allowClinicianToMarkAsPaid: clinicActions?.allowClinicianToMarkAsPaid ?? false
            },
            cancellationReasons: cancellationAndRefundSettings?.cancellationReasons ?? [],
            infoTextToPatientCancelOrReschedule: {
                early: infoTextToPatientCancelOrReschedule?.early ?? { en: '', se: '' },
                late: infoTextToPatientCancelOrReschedule?.late ?? { en: '', se: '' }
            }
        }

        this.setState({ form })
    }



    get = () => {

    }

    componentDidMount() {
        this.get();
        this.setInitialData();
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {
        const formPrevState = prevState?.form ? JSON.stringify(prevState.form) : null;
        const formState = this.state?.form ? JSON.stringify(this.state.form) : null;
        if (formPrevState !== formState) {
            this.onChange();
        }

        if (prevProps.selectedClinic !== this.props.selectedClinic) {
            this.setInitialData();
        }

    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }


    onChange = () => {
        const form = this.state.form;
        if (this.props.onChange) {
            this.props.onChange(form, this._isInitial);
        }
        if (this._isInitial)
            this._isInitial = false;
    }



    render() {
        const isOpen = this.props.isOpen;

        const currency = this.getCurrency();
        const errors = this.state.errors ?? {};
        const form = this.state.form ?? {};

        const { colorLateEarly, earlyColor, lateColor } = getColorLateEarly();

        const groupData = this.getGroupData();

        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);

        const pageTitle = EXTENDED_PAYMENT_MANAGEMENT ? 'Cancellation and Refund Settings' : 'Cancellation Settings';

        return (
            <div className='cancellation-and-refund-settings-wrap'>

                <div className='section-title'>
                    {pageTitle.translate(this.props.lang)}
                </div>
                <Row>
                    <Col lg='12'>
                        <FormGroup>
                            <Label>
                                {
                                    colorLateEarly ?
                                        <>{'Department'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation period'.translate(this.props.lang)}</>
                                        :
                                        'Department late cancellation period'.translate(this.props.lang)
                                }
                            </Label>
                            <div className='input-with-suffix-text-wrap info-tooltip-wrap'>
                                <Input
                                    type='text'
                                    value={form?.lateCancellationPeriod ?? ''}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, "");
                                        let form = { ...this.state.form };
                                        form.lateCancellationPeriod = Number(value);
                                        let setObj = { form };

                                        this.setState(setObj);
                                    }}
                                />
                                <div className='suffix-text'>{'h before scheduled appointment'.translate(this.props.lang)}</div>

                                <div className='info-tooltip'>
                                    <Isvg src={notesIcon} />
                                    <div className='tooltip-text'>{'Department late cancellation period tooltip'.translate(this.props.lang)}</div>
                                </div>
                            </div>
                        </FormGroup>
                    </Col>


                </Row>
                <Row>
                    {
                        EXTENDED_PAYMENT_MANAGEMENT ?
                            <>
                                <Col lg='12'>
                                    <div className='section-subtitle'>
                                        {'Patient actions'.translate(this.props.lang)}
                                    </div>
                                </Col>
                                {/* <Col lg='4'>
                                    <div className='checkbox-column-wrap'> */}
                                {/* <Checkbox
                                            checked={form?.patientActions?.markEarlyCancellationAsRefundRequest ?? false}
                                            disabled={form?.patientActions?.automaticallyRefundEarlyCancellations || form?.patientActions?.preventEarlyCancellation || form?.patientActions?.preventEarlyRescheduling ? true : false}
                                            onChange={() => {
                                                let form = { ...this.state.form };

                                                if (form?.patientActions?.automaticallyRefundEarlyCancellations || form?.patientActions?.preventEarlyCancellation || form?.patientActions?.preventEarlyRescheduling) {
                                                    return;
                                                }
                                                let patientActions = { ...form?.patientActions };
                                                patientActions.markEarlyCancellationAsRefundRequest = !patientActions.markEarlyCancellationAsRefundRequest;
                                                form.patientActions = patientActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={
                                                colorLateEarly ?
                                                    <>{'Mark'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation as "Refund requested"'.translate(this.props.lang)}</>
                                                    :
                                                    'Mark early cancellation as "Refund requested"'.translate(this.props.lang)
                                            }
                                            tooltipV2={'Mark early cancellation as "Refund requested" tooltip'.translate(this.props.lang)}
                                        /> */}
                                {/* <Checkbox
                                            checked={false}
                                            disabled={true}
                                            suffixText={'Feature coming soon!'.translate(this.props.lang)}
                                            suffixTextClassName='coming-soon-text'
                                            lighterText={true}
                                            // checked={form?.patientActions?.automaticallyRefundEarlyCancellations ?? false}
                                            // disabled={form?.patientActions?.preventEarlyCancellation || form?.patientActions?.preventEarlyRescheduling ? true : false}
                                            onChange={() => {
                                                return;
                                                let form = { ...this.state.form };

                                                if (form?.patientActions?.preventEarlyCancellation || form?.patientActions?.preventEarlyRescheduling) {
                                                    return;
                                                }
                                                let patientActions = { ...form?.patientActions };
                                                patientActions.automaticallyRefundEarlyCancellations = !patientActions.automaticallyRefundEarlyCancellations;
                                                if (patientActions.automaticallyRefundEarlyCancellations) {
                                                    // patientActions.markEarlyCancellationAsRefundRequest = true
                                                }
                                                form.patientActions = patientActions;


                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={
                                                colorLateEarly ?
                                                    <>{'Automatically refund'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellations'.translate(this.props.lang)} ({'Stripe only'.translate(this.props.lang)})</>
                                                    :
                                                    `${'Automatically refund early cancellations'.translate(this.props.lang)} (${'Stripe only'.translate(this.props.lang)})`
                                            }
                                            tooltipV2={'Automatically refund early cancellations tooltip'.translate(this.props.lang)}
                                        /> */}
                                {/* </div>
                                </Col> */}

                                <Col lg='4'>
                                    <div className='checkbox-column-wrap'>
                                        <Checkbox
                                            checked={form?.patientActions?.preventEarlyCancellation ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };
                                                let patientActions = { ...form?.patientActions };
                                                patientActions.preventEarlyCancellation = !patientActions.preventEarlyCancellation;
                                                if (patientActions.preventEarlyCancellation) {
                                                    // patientActions.markEarlyCancellationAsRefundRequest = false;
                                                    patientActions.automaticallyRefundEarlyCancellations = false;
                                                }
                                                form.patientActions = patientActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={
                                                colorLateEarly ?
                                                    <>{'Prevent'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}</>
                                                    :
                                                    'Prevent early cancellation'.translate(this.props.lang)
                                            }
                                            tooltipV2={'"Request new time" is seen as cancellation'.translate(this.props.lang)}
                                            disabled={false}
                                        />
                                        <Checkbox
                                            checked={form?.patientActions?.preventEarlyRescheduling ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };
                                                let patientActions = { ...form?.patientActions };
                                                patientActions.preventEarlyRescheduling = !patientActions.preventEarlyRescheduling;
                                                if (patientActions.preventEarlyRescheduling) {
                                                    // patientActions.markEarlyCancellationAsRefundRequest = false;
                                                    patientActions.automaticallyRefundEarlyCancellations = false;
                                                }
                                                form.patientActions = patientActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={
                                                colorLateEarly ?
                                                    <>{'Prevent'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'rescheduling'.translate(this.props.lang)} ({'Web booking only'.translate(this.props.lang)})</>
                                                    :
                                                    `${'Prevent early rescheduling'.translate(this.props.lang)} (${'Web booking only'.translate(this.props.lang)})`
                                            }
                                            disabled={false}
                                        />
                                    </div>
                                </Col>


                                <Col lg='4'>
                                    <div className='checkbox-column-wrap'>
                                        <Checkbox
                                            checked={form?.patientActions?.preventLateCancellation ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };
                                                let patientActions = { ...form?.patientActions };
                                                patientActions.preventLateCancellation = !patientActions.preventLateCancellation;
                                                form.patientActions = patientActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={
                                                colorLateEarly ?
                                                    <>{'Prevent'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}</>
                                                    :
                                                    'Prevent late cancellation'.translate(this.props.lang)
                                            }
                                            tooltipV2={'"Request new time" is seen as cancellation'.translate(this.props.lang)}
                                            disabled={false}
                                        />
                                        <Checkbox
                                            checked={form?.patientActions?.preventLateRescheduling ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };
                                                let patientActions = { ...form?.patientActions };
                                                patientActions.preventLateRescheduling = !patientActions.preventLateRescheduling;
                                                form.patientActions = patientActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={
                                                colorLateEarly ?
                                                    <>{'Prevent'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'rescheduling'.translate(this.props.lang)} ({'Web booking only'.translate(this.props.lang)})</>
                                                    :
                                                    `${'Prevent late rescheduling'.translate(this.props.lang)} (${'Web booking only'.translate(this.props.lang)})`
                                            }
                                            disabled={false}
                                        />
                                    </div>
                                </Col>
                                <Col lg='6' style={{ marginTop: 20 }}>
                                    <div className='section-subtitle'>
                                        {'Clinic actions'.translate(this.props.lang)}
                                    </div>

                                    <div className='checkbox-column-wrap'>
                                        {/* <Checkbox
                                            checked={form?.clinicActions?.markEarlyCancellationAsRefundRequest ?? false}
                                            disabled={form?.clinicActions?.automaticallyRefundEarlyCancellations ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };

                                                if (form?.clinicActions?.automaticallyRefundEarlyCancellations) {
                                                    return;
                                                }
                                                let clinicActions = { ...form?.clinicActions };
                                                clinicActions.markEarlyCancellationAsRefundRequest = !clinicActions.markEarlyCancellationAsRefundRequest;
                                                form.clinicActions = clinicActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={
                                                colorLateEarly ?
                                                    <>{'Mark'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation as "Refund requested"'.translate(this.props.lang)}</>
                                                    :
                                                    'Mark early cancellation as "Refund requested"'.translate(this.props.lang)
                                            }
                                        /> */}
                                        {/* <Checkbox
                                            checked={false}
                                            disabled={true}
                                            suffixText={'Feature coming soon!'.translate(this.props.lang)}
                                            suffixTextClassName='coming-soon-text'
                                            lighterText={true}
                                            // checked={form?.clinicActions?.automaticallyRefundEarlyCancellations ?? false}
                                            onChange={() => {
                                                return;
                                                let form = { ...this.state.form };
                                                let clinicActions = { ...form?.clinicActions };
                                                clinicActions.automaticallyRefundEarlyCancellations = !clinicActions.automaticallyRefundEarlyCancellations;
                                                if (clinicActions.automaticallyRefundEarlyCancellations) {
                                                    // clinicActions.markEarlyCancellationAsRefundRequest = true
                                                }
                                                form.clinicActions = clinicActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={
                                                colorLateEarly ?
                                                    <>{'Automatically refund'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellations'.translate(this.props.lang)} ({'Stripe only'.translate(this.props.lang)})</>
                                                    :
                                                    `${'Automatically refund early cancellations'.translate(this.props.lang)} (${'Stripe only'.translate(this.props.lang)})`
                                            }
                                        // disabled={false}
                                        /> */}
                                        {/* <Checkbox
                                            checked={form?.clinicActions?.allowLateCancellationRefund ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };
                                                let clinicActions = { ...form?.clinicActions };
                                                clinicActions.allowLateCancellationRefund = !clinicActions.allowLateCancellationRefund;
                                                form.clinicActions = clinicActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={
                                                colorLateEarly ?
                                                    <>{'Allow'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation refund'.translate(this.props.lang)}</>
                                                    :
                                                    'Allow late cancellation refund'.translate(this.props.lang)
                                            }
                                            disabled={false}
                                        /> */}
                                        <Checkbox
                                            checked={form?.clinicActions?.allowClinicianToRefundPayment ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };
                                                let clinicActions = { ...form?.clinicActions };
                                                clinicActions.allowClinicianToRefundPayment = !clinicActions.allowClinicianToRefundPayment;
                                                form.clinicActions = clinicActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={'Allow "Clinician" to refund and cancel unpaid payment'.translate(this.props.lang)}
                                            disabled={false}
                                        />

                                        <Checkbox
                                            checked={form?.clinicActions?.allowClinicianToCreateAndEditPayments ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };
                                                let clinicActions = { ...form?.clinicActions };
                                                clinicActions.allowClinicianToCreateAndEditPayments = !clinicActions.allowClinicianToCreateAndEditPayments;
                                                form.clinicActions = clinicActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={'Allow "Clinician" to create and edit payments'.translate(this.props.lang)}
                                            disabled={false}
                                        />
                                        {/* <Checkbox
                                            checked={form?.clinicActions?.allowClinicianToCancelAnUnpaidPayment ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };
                                                let clinicActions = { ...form?.clinicActions };
                                                clinicActions.allowClinicianToCancelAnUnpaidPayment = !clinicActions.allowClinicianToCancelAnUnpaidPayment;
                                                form.clinicActions = clinicActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={'Allow "Clinician" to cancel an unpaid payment'.translate(this.props.lang)}
                                            disabled={false}
                                        /> */}
                                        <Checkbox
                                            checked={form?.clinicActions?.allowClinicianToAttachInvoices ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };
                                                let clinicActions = { ...form?.clinicActions };
                                                clinicActions.allowClinicianToAttachInvoices = !clinicActions.allowClinicianToAttachInvoices;
                                                form.clinicActions = clinicActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={'Allow "Clinician" to attach invoices'.translate(this.props.lang)}
                                            disabled={false}
                                        />
                                        <Checkbox
                                            checked={form?.clinicActions?.allowClinicianToMarkAsPaid ?? false}
                                            onChange={() => {
                                                let form = { ...this.state.form };
                                                let clinicActions = { ...form?.clinicActions };
                                                clinicActions.allowClinicianToMarkAsPaid = !clinicActions.allowClinicianToMarkAsPaid;
                                                form.clinicActions = clinicActions;

                                                let setObj = { form };

                                                this.setState(setObj);
                                            }}
                                            label={'Allow "Clinician" to mark payments as "Paid"'.translate(this.props.lang)}
                                            disabled={false}
                                        />
                                    </div>
                                </Col>
                                <Col lg='6' style={{ marginTop: 20 }}>
                                    <div className='section-subtitle info-tooltip-wrap'>
                                        {'Reasons'.translate(this.props.lang)}
                                        <div className='info-tooltip'>
                                            <Isvg src={notesIcon} />
                                            <div className='tooltip-text'>{'Cancellation reasons tooltip'.translate(this.props.lang)}</div>
                                        </div>
                                    </div>
                                    <FormGroup>
                                        <DynamicListText
                                            lang={this.props.lang}
                                            onChange={(value) => {
                                                let form = { ...this.state.form };
                                                form.cancellationReasons = value;
                                                let setObj = { form };
                                                this.setState(setObj);
                                            }}
                                            value={form?.cancellationReasons ?? []}
                                            multilang={true}

                                        />
                                    </FormGroup>
                                </Col>
                            </>
                            :
                            null
                    }
                    {
                        EXTENDED_PAYMENT_MANAGEMENT || true ?
                            <>
                                <Col lg='12' style={{ marginTop: 20 }}>
                                    <FormGroup>
                                        <Label className='info-tooltip-wrap'>
                                            <div>
                                                {
                                                    colorLateEarly ?
                                                        <>{'Information shown to patient when cancelling/rescheduling'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span>:</>
                                                        :
                                                        'Information shown to patient when cancelling/rescheduling early'.translate(this.props.lang)
                                                }
                                            </div>
                                            <div className='info-tooltip'>
                                                <Isvg src={notesIcon} />
                                                <div className="tooltip-text">{'Links in this field are automatically converted into clickable text labelled “Click here”'.translate(this.props.lang)}</div>
                                            </div>
                                        </Label>
                                        <div className='multi-lang-inputs-wrap'>
                                            <FormGroup>
                                                <Label>{'SE'.translate(this.props.lang)}:</Label>
                                                <Input
                                                    type='textarea'
                                                    placeholder={'Enter text'.translate(this.props.lang)}
                                                    value={form?.infoTextToPatientCancelOrReschedule?.early?.se ?? ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        let form = { ...this.state.form };
                                                        let infoTextToPatientCancelOrReschedule = { ...form?.infoTextToPatientCancelOrReschedule };
                                                        infoTextToPatientCancelOrReschedule.early = { ...infoTextToPatientCancelOrReschedule.early };
                                                        infoTextToPatientCancelOrReschedule.early.se = value;
                                                        form.infoTextToPatientCancelOrReschedule = infoTextToPatientCancelOrReschedule;
                                                        let setObj = { form };
                                                        this.setState(setObj);
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{'EN'.translate(this.props.lang)}:</Label>
                                                <Input
                                                    type='textarea'
                                                    placeholder={'Enter text'.translate(this.props.lang)}
                                                    value={form?.infoTextToPatientCancelOrReschedule?.early?.en ?? ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        let form = { ...this.state.form };
                                                        let infoTextToPatientCancelOrReschedule = { ...form?.infoTextToPatientCancelOrReschedule };
                                                        infoTextToPatientCancelOrReschedule.early = { ...infoTextToPatientCancelOrReschedule.early };
                                                        infoTextToPatientCancelOrReschedule.early.en = value;
                                                        form.infoTextToPatientCancelOrReschedule = infoTextToPatientCancelOrReschedule;
                                                        let setObj = { form };
                                                        this.setState(setObj);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col lg='12' >
                                    <FormGroup>
                                        <Label className='info-tooltip-wrap'>
                                            <div>
                                                {
                                                    colorLateEarly ?
                                                        <>{'Information shown to patient when cancelling/rescheduling'.translate(this.props.lang)} <span className='color-late-early-span' style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span>:</>
                                                        :
                                                        'Information shown to patient when cancelling/rescheduling late'.translate(this.props.lang)
                                                }
                                            </div>
                                            <div className='info-tooltip'>
                                                <Isvg src={notesIcon} />
                                                <div className="tooltip-text">{'Links in this field are automatically converted into clickable text labelled “Click here”'.translate(this.props.lang)}</div>
                                            </div>
                                        </Label>
                                        <div className='multi-lang-inputs-wrap'>
                                            <FormGroup>
                                                <Label>{'SE'.translate(this.props.lang)}:</Label>
                                                <Input
                                                    type='textarea'
                                                    placeholder={'Enter text'.translate(this.props.lang)}
                                                    value={form?.infoTextToPatientCancelOrReschedule?.late?.se ?? ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        let form = { ...this.state.form };
                                                        let infoTextToPatientCancelOrReschedule = { ...form?.infoTextToPatientCancelOrReschedule };
                                                        infoTextToPatientCancelOrReschedule.late = { ...infoTextToPatientCancelOrReschedule.late };
                                                        infoTextToPatientCancelOrReschedule.late.se = value;
                                                        form.infoTextToPatientCancelOrReschedule = infoTextToPatientCancelOrReschedule;
                                                        let setObj = { form };
                                                        this.setState(setObj);
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{'EN'.translate(this.props.lang)}:</Label>
                                                <Input
                                                    type='textarea'
                                                    placeholder={'Enter text'.translate(this.props.lang)}
                                                    value={form?.infoTextToPatientCancelOrReschedule?.late?.en ?? ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        let form = { ...this.state.form };
                                                        let infoTextToPatientCancelOrReschedule = { ...form?.infoTextToPatientCancelOrReschedule };
                                                        infoTextToPatientCancelOrReschedule.late = { ...infoTextToPatientCancelOrReschedule.late };
                                                        infoTextToPatientCancelOrReschedule.late.en = value;
                                                        form.infoTextToPatientCancelOrReschedule = infoTextToPatientCancelOrReschedule;
                                                        let setObj = { form };
                                                        this.setState(setObj);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </>
                            :
                            null
                    }



                </Row>


            </div>
        );
    }
}


export default CancellationAndRefundSettings;